var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#1f2923",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6462 2.64671C11.8413 2.4513 12.1579 2.45107 12.3533 2.64618L14.7007 4.99014L14.7033 4.99271L14.7033 4.99272L14.7054 4.99485L14.7054 4.99488C14.7197 5.00931 14.7302 5.02 14.7408 5.03105C14.7514 5.04208 14.7617 5.05308 14.7755 5.0679L14.7776 5.0702L14.7801 5.07285L14.7801 5.07286C15.2687 5.60532 15.5082 6.29681 15.4998 6.98515C15.4999 6.99008 15.5 6.99503 15.5 7C15.5 7.01223 15.4996 7.02436 15.4987 7.03636C15.4787 7.70096 15.2273 8.35885 14.7458 8.86391L12.3801 11.345C12.1895 11.5449 11.873 11.5524 11.6732 11.3619C11.4733 11.1713 11.4658 10.8548 11.6564 10.655L14.022 8.17384C14.2072 7.9796 14.3388 7.74771 14.4164 7.5H12C8.96243 7.5 6.5 9.96243 6.5 13V14C6.5 14.2761 6.27614 14.5 6 14.5C5.72386 14.5 5.5 14.2761 5.5 14V13C5.5 9.41015 8.41015 6.5 12 6.5H14.4446C14.3757 6.22586 14.2425 5.96668 14.0448 5.75062L14.019 5.72309L13.9925 5.69611L11.6467 3.35382C11.4513 3.1587 11.4511 2.84212 11.6462 2.64671ZM4 15.5C4 15.2238 4.22386 15 4.5 15H15.5C15.7761 15 16 15.2238 16 15.5C16 15.7761 15.7761 16 15.5 16H4.5C4.22386 16 4 15.7761 4 15.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowExport);
export default __webpack_public_path__ + "static/media/arrowExport.92fc6948cee65998492ace36767375a8.svg";
export { ForwardRef as ReactComponent };